export default __webpack_public_path__ + "static/media/sim.082bd61c.svg";